import React from 'react';

export interface JumpNavSection {
  key: string;
  label: string;
  number: string;
}

interface SectionJumpNavProps {
  sections: JumpNavSection[];
}

const scrollToSection = (key: string) => {
  const el = document.querySelector(`[data-section="${key}"]`);
  if (!el) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
};

const SectionJumpNav: React.FC<SectionJumpNavProps> = ({ sections }) => (
  <nav
    aria-label="Navegación de secciones de la consulta"
    className="mb-3"
    style={{
      position: 'sticky',
      top: 0,
      zIndex: 900,
      background: 'var(--ec-surface, #FFFFFF)',
      border: '1px solid var(--ec-border, #E2E8F0)',
      borderRadius: 'var(--ec-radius-sm, 8px)',
      padding: '6px 8px',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }}
  >
    {sections.map((s) => (
      <button
        key={s.key}
        type="button"
        onClick={() => scrollToSection(s.key)}
        style={{
          background: 'transparent',
          border: 'none',
          padding: '4px 10px',
          fontSize: 12,
          fontWeight: 600,
          color: 'var(--ec-text-secondary, #64748B)',
          cursor: 'pointer',
        }}
      >
        <span style={{ color: 'var(--ec-primary, #0EA5A4)', marginRight: 4 }}>{s.number}</span>
        {s.label}
      </button>
    ))}
  </nav>
);

export default SectionJumpNav;
